export default __webpack_public_path__ + "static/media/dpo.a29103c0.svg";